// extracted by mini-css-extract-plugin
export default {"productDescription":"Raa-z","featuredDescription":"Saa-z","description":"Taa-z","more":"Uaa-z","descriptionSku":"Vaa-z"};